import { Fragment } from 'react';

import StyledLink from '@/components/common/StyledLink';

import styles from './Breadcrumb.module.scss';

type BreadcrumbLinkType = {
  label: string;
  href: string;
}

type BreadcrumbProps = {
  links: BreadcrumbLinkType[];
  separator?: string;
}

export const Breadcrumb = ({ links, separator = '|' }: BreadcrumbProps) => {
  return (
    <nav className={styles.container} aria-label="breadcrumb" data-test-id="breadcrumb-millesima" data-rbf="breadcrumb-millesima"
      sensefuel-id="breadcrumb-millesima">
      {links.map((link, index) => {
        return (index !== links.length - 1) ? (
          <Fragment key={index}>
            <StyledLink id={`breadcrumb-link-${index}`} label={link.label} href={link.href} isUnderlined={false}/>
            <div className={styles.separator}>{separator}</div>
          </Fragment>
        ) : (
          <div id={`breadcrumb-link-${index}`} className={styles['last-link']} key={index}>
            {link.label}
          </div>
        );
      })}
    </nav>
  );
};

export default Breadcrumb;
